import React, { Component, useEffect, useState } from "react";

import { FormAndLiveness } from "@ahrvocomply/ahrvo-comply-react-sdk-sandbox";
import axios from "axios";
import { Puff } from "react-loader-spinner";
import { useLocation, useNavigate } from "react-router";
import "@ahrvocomply/ahrvo-comply-react-sdk-sandbox/dist/index.css";
import "./onboarding.css";
export default function Onboarding() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [token, setToken] = useState("");

  const { state } = useLocation();

  const saveCart = async () => {
    try {
      const cartData = JSON.parse(localStorage.getItem("cartDataStore"));
      if (Array.isArray(cartData) && cartData.length > 0) {
        const response = await axios.post(`/save-cart/`, cartData, {
          headers: {
            "Content-Type": "application/json",
            Authorization: localStorage.getItem("jwt_ahrvo"),
          },
        });
      }
    } catch (error) {
      alert("An error occurred while saving card details");
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchToken();
  }, []);

  const fetchToken = async () => {
    try {
      const response = await axios.get(`/onboarding_jwt/`, {
        headers: {
          "Content-Type": "application/json",
        },
      });

      setToken(response.data.jwt);
      return response;
    } catch (error) {
      console.log("eee", error);
    }
  };

  if (!token || loading) {
    return (
      <div
        style={{
          width: "100%",
          height: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div
          class="spinner-border"
          role="status"
          style={{ width: "3rem", height: "3rem" }}
        ></div>
      </div>
    );
  }

  return (
    <FormAndLiveness
      onComplete={async () => {
        setLoading(true);
        await saveCart();
        setTimeout(() => navigate("/welcome"), 5000);
      }}
      showCompanyApplicantType={true}
      client_webapp_url="https://paypal.kycaml.systems" // (optinal property)
      nftid="mainnet" // If Mint NFT is being used - (optinal property)
      isWalletRequired="true" // If wallet field should be required, by default its optional (optinal property)
      isExpiryRequired="true" // If Expirty Date for ID card should be required, by default its optional (optinal property)
      token={token}
      formType={state?.formType || "form"}
      showPaymentFields={true}
    />
  );
}
